<template>
    <rkm-form
        ref="Form"
        show-legend
    >
        <rkm-row>
            <rkm-col>
                <rkm-form-select
                    :options="destinos"
                    :validations="validations.destino"
                    label="Destino"
                    show-default-option
                    text-field="nome"
                    v-model="model.destinoId"
                    value-field="id"
                />
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>
// Mixins.
import { object } from '@/mixins'

export default {
    computed: {
        validations() {

            return {
                destino: { required: true },
            }
        },
        destinos() {

            return this.data.form.destinos
                .filter(d => !this.destinosPrestadoresIds.includes(d.id))
        },
        destinosPrestadoresIds() {

            return this.data.model.prestadoresExternos.map(p => p.destinoId)
        }
    },
    data: () => ({
        model: {
            id: null,
            ativo: true,
            destinoId: null,
            exames: [],
            procedimentosCirurgicos: [],
            especialidades: [],
        }
    }),
    methods: {
        save() {

            this.$refs.Form.validate()
                .then(valid => {

                    if (!valid) return

                    this.data.model.prestadoresExternos.push(this.prepareData())

                    this.$emit('save')
                })
        },
        prepareData() {

            const data = this.clone(this.model)

            data.destinoNome = this.data.form.destinos.find(d => d.id === data.destinoId).nome

            return data
        }
    },
    mixins: [object],
    props: {
        data: { type: Object, required: true },
    },
}
</script>